site.fullscreenmenu = {
	selector: '#mainmenu',

	init: function() {
		this.bindMainmenuToggleAndBodyClick();
		this.addExpandAndShrinkButtons();
		this.bindExpandAndShrinkButtons();
		this.bindClick();
		this.openActiveMenus();
		this.clickOnSelectedNode();
	},

	bindMainmenuToggleAndBodyClick: function() {
		$('#mainmenuToggle').on('click touchstart', function (e) {
			e.stopPropagation();
			e.preventDefault();

			var menuOpen = $('body').hasClass('mainmenu-open');
			site.fullscreenmenu.mobileToggle(e, menuOpen);

			if (!menuOpen) {
				$(this).attr('aria-expanded', true);
			}
			else {
				$(this).removeAttr('aria-expanded');
			}

			$(site.fullscreenmenu.selector).on('click touchstart', function (e) {
				e.stopPropagation();
			});

			$('body.mainmenu-open').on('click touchstart', function (e) {
				var $clickedElement = $(e.target);
				if ($clickedElement.is('#fullscreenMenu') || $clickedElement.parents('#fullscreenMenu').length) {
					return;
				}
				$('body').removeClass('mainmenu-open');
				site.fullscreenmenu.closeMenu();
			});
		});
	},

	mobileToggle: function (e, menuOpen) {
		$('body').toggleClass('mainmenu-open');
		var $label = $("label[for='#mainmenuToggle']");
		$label.text($label.attr('data-text-opened'));

		if (menuOpen) {
			site.fullscreenmenu.closeMenu();
		}
	},

	closeMenu: function() {
		var $body = $('body');
		$body.addClass('mainmenu-closing');

		var $label = $("label[for='#mainmenuToggle']");
		$label.text($label.attr('data-text-closed'));

		setTimeout(function() {
			$('body').removeClass('mainmenu-closing');
		},300);
	},

	addExpandAndShrinkButtons: function() {
		$('.fsm__right .menu > li.children > a').after('<button class="expand">+</button><button class="shrink">-</button>');
	},

	bindExpandAndShrinkButtons: function() {
		$('.expand, .shrink', $('li.children')).on('click', function(e) {
			e.preventDefault();
			var $menu = $(this).siblings('.menu');
			$menu.slideToggle('200');
			$(this).parent('li').toggleClass('open');
		});
	},

	bindClick: function() {
		$('.fsm__right .level1 > a').on('click', function(e) {
			var classList = $(this).parents('.level1').attr('class').split(/\s+/),
				isAlreadyClicked = $(this).parents('.level1').is('.showMe');
			for (var i = 0; i < classList.length; i++) {
				if (classList[i].startsWith('ele-')) {
					targetClass = classList[i];
				}
			}

			var targetHasChildren = $('.' + targetClass, '.fsm__left').find('.level2').length > 0;
			if (!isAlreadyClicked && targetHasChildren) {
				e.preventDefault();
				$('.level1').removeClass('showMe');
				$('.' + targetClass, $('.fsm__left')).addClass('showMe');
				$('.' + targetClass, $('.fsm__right')).addClass('showMe');
			}
		});
		$('.fsm__left a').on('click', function() {
			if ($('body').is('.hotelsOverview')) {
				var href = $(this).attr('href');
				if (href.includes('#')) {
					var hashPos = href.indexOf('#');
					if (hashPos) {
						var classValue = href.substr(hashPos + 1);
						$('#mainmenuToggle').click();
						$('a.' + classValue).click();
					}
				}
			}
		});
	},

	openActiveMenus: function() {
		$("li[class*='selectedLevel']", $('.fsm__right')).each(function() {
			$(this).find('> .expand').click();
		});
	},

	clickOnSelectedNode: function() {
		var $fsmLeft = $('.fsm__left'),
			$fsmRight = $('.fsm__right'),
			$selected = $('.selectedLevel1');
		if ($selected.length) {
			$selected.addClass('showMe');
		} else {
			$('.level1:first-child', $fsmLeft).addClass('showMe');
			$('.level1:first-child', $fsmRight).addClass('showMe');
		}
	}
};

site.inits.push('site.fullscreenmenu.init()');
